import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Loader2, Sparkles } from "lucide-react";
import { api, getAdminToken } from "../../lib/api";
import { streamPost } from "../../lib/stream";

const IDEAS = ["Order early for Christmas delivery", "Gift vouchers from €20 – they design their own", "Club fundraiser: clubs earn €5–€15 per shield", "New AI backgrounds – get creative"];

export const CaptionWriter = () => {
  const [topic, setTopic] = useState("");
  const [platform, setPlatform] = useState("Instagram");
  const [out, setOut] = useState("");
  const [busy, setBusy] = useState(false);
  const [enabled, setEnabled] = useState(true);
  useEffect(() => { api.get("/help/status").then((r) => setEnabled(r.data.enabled)).catch(() => {}); }, []);
  const write = async (e) => {
    e.preventDefault();
    setOut(""); setBusy(true);
    try { await streamPost("/admin/ai/caption", { topic, platform }, (t) => setOut((o) => o + t), { Authorization: `Bearer ${getAdminToken()}` }); }
    catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  return (
    <section className="mt-8 border-2 border-slate-900 bg-white p-5" data-testid="caption-writer">
      <h2 className="font-display flex items-center gap-2 text-2xl font-black uppercase"><Sparkles className="h-5 w-5 text-fuchsia-500" /> AI caption writer</h2>
      <p className="mt-1 text-sm text-slate-600">Say what the post is about and Claude writes 3 ready-to-paste captions.</p>
      {!enabled && <p className="mt-3 border-2 border-amber-400 bg-amber-50 p-3 text-sm font-bold" data-testid="caption-writer-off">Claude isn't switched on yet – add your Anthropic API key to use the caption writer and the customer help chat.</p>}
      <form onSubmit={write} className="mt-4 space-y-3">
        <div className="flex flex-wrap gap-1.5">{IDEAS.map((i) => (
          <button key={i} type="button" onClick={() => setTopic(i)} className="border-2 border-slate-200 px-2.5 py-1 text-xs font-bold hover:border-slate-900" data-testid="caption-idea">{i}</button>))}</div>
        <textarea value={topic} onChange={(e) => setTopic(e.target.value)} rows={2} maxLength={600} required minLength={3} placeholder="e.g. 20% off this weekend with code SS20 for St Brigid's parents"
          className="w-full border-2 border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-900" data-testid="caption-topic-input" />
        <div className="flex flex-wrap items-center gap-2">
          {["Instagram", "Facebook", "WhatsApp", "TikTok"].map((p) => (
            <button key={p} type="button" onClick={() => setPlatform(p)} aria-pressed={platform === p} data-testid={`caption-platform-${p.toLowerCase()}`}
              className={`border-2 px-3 py-1.5 text-xs font-bold ${platform === p ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200"}`}>{p}</button>))}
          <button type="submit" disabled={busy || !enabled || topic.trim().length < 3} className="btn-blaze ml-auto flex items-center gap-2 px-4 py-2 text-sm" data-testid="caption-write-button">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />} Write captions</button>
        </div>
      </form>
      {out && (
        <div className="mt-4 border-2 border-lime-500 bg-lime-50 p-3">
          <button type="button" onClick={() => navigator.clipboard.writeText(out).then(() => toast.success("Copied"))} className="float-right flex items-center gap-1 text-xs font-bold underline" data-testid="caption-copy-button"><Copy className="h-3.5 w-3.5" /> Copy all</button>
          <div className="whitespace-pre-wrap text-sm" data-testid="caption-output">{out}</div>
        </div>
      )}
    </section>
  );
};
